// Highcharts plugin to hook LegendExpander
(function (H) {
  if (!H) {
    return;
  }
  H.wrap(H.Legend.prototype, 'render', function (proceed) {
    proceed.call(this);
    let limit = this.chart.options.seriesLimit;
    let length = this.chart.series.length;
    if (length && limit && length > limit) {
      new LegendExpander(this.chart);
    }
  });
}(Highcharts));

export default class LegendExpander {
  constructor(chart) {
    this.chart = chart;
    this.limit = this.chart.userOptions.seriesLimit;

    // Clear previous rendered DOM
    $(this.chart.container).find('.c-chart__legend-expand, .c-chart__legend-expand-tooltip').remove();

    // Cache DOM and initialize values
    this.$legendContainer = $(this.chart.container).find('.highcharts-legend').filter('div');
    this.$legendItems = this.$legendContainer.find('.highcharts-legend-item').parent();

    // $legendExpandContainer
    this.$legendExpandContainer = this.$legendContainer.parent().find('.c-chart__legend-expand');
    this.$legendExpandContainer = $('<div class="c-chart__legend-expand">');
    this.$legendContainer.parent().append(this.$legendExpandContainer);
    this.$legendExpandContainer.attr('data-number', `+${this.chart.series.length-this.limit}`);
    this.$legendExpandContainer.attr('data-items', 'other');

    // Legend items
    this.$legendExpandItems = $('<div>').append(this.$legendItems.children().slice(this.limit));
    this.$legendExpandTooltip = $('<div class="c-chart__legend-expand-tooltip">');
    this.$legendExpandTooltip.append(this.$legendExpandItems);
    this.$legendExpandTooltipWrapper = this.$legendContainer.parent().find('.c-chart__legend-expand-tooltip-wrapper');
    this.$legendExpandTooltipWrapper = $('<div class="c-chart__legend-expand-tooltip-wrapper">');
    this.$legendExpandTooltipWrapper.append(this.$legendExpandTooltip);
    this.$legendExpandContainer.after(this.$legendExpandTooltipWrapper);

    // Add nanoscroller
    this.$legendExpandTooltip.addClass('c-nano');
    this.$legendExpandItems.addClass('c-nano__content');
    this.$legendExpandTooltip.nanoScroller({
      nanoClass: 'c-nano',
      paneClass: 'c-nano__scrollbar',
      sliderClass: 'c-nano__thumb',
      contentClass: 'c-nano__content',
      alwaysVisible: true
    });

    // Add dropdown
    this.$legendExpandContainer.on('click', function () {
      $(this).toggleClass('is-active');
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/common/analyticsPanel/legendExpander.js
 **/